/* eslint-disable radix */
/* eslint-disable jsdoc/require-returns */
/* eslint-disable @typescript-eslint/ban-types */
/* eslint-disable @typescript-eslint/no-inferrable-types */
/* eslint-disable valid-jsdoc */
/* eslint-disable jsdoc/require-param */
import { sum, getPoint, templateAnimate } from '../../common/utils/helper';
import { PathOption } from '@syncfusion/ej2-svg-base';
import { ColumnSeries } from './column-series';
/**
 * `HistogramSeries` Module used to render the histogram series.
 */
export class HistogramSeries extends ColumnSeries {
    /**
     * Render Histogram series.
     *
     * @returns {void}
     * @private
     */
    render(series) {
        super.render(series);
        if (series.showNormalDistribution) {
            this.renderNormalDistribution(series);
        }
    }
    /**
     * To calculate bin interval for Histogram series.
     *
     * @returns {void}
     * @private
     */
    calculateBinInterval(yValues, series) {
        const mean = sum(yValues) / yValues.length;
        let sumValue = 0;
        for (const value of yValues) {
            sumValue += (value - mean) * (value - mean);
        }
        series.histogramValues.mean = mean;
        series.histogramValues.sDValue = Math.round(Math.sqrt(Math.abs(sumValue / yValues.length - 1)));
        series.histogramValues.binWidth = series.binInterval ||
            Math.round((3.5 * series.histogramValues.sDValue) / Math.pow(yValues.length, 1 / 3)) || 1;
    }
    /**
     * Add data points for Histogram series.
     *
     * @returns {object[]} data
     * @private
     */
    processInternalData(data, series) {
        const updatedData = [];
        const yValues = [];
        const keys = Object.keys(data);
        for (let i = 0; i < keys.length; i++) {
            const key = keys[i];
            yValues.push(data[key][series.yName]);
        }
        series.histogramValues = {
            yValues: yValues
        };
        let min = Math.min(...series.histogramValues.yValues);
        const max = Math.max(...series.histogramValues.yValues);
        this.calculateBinInterval(series.histogramValues.yValues, series);
        const binWidth = series.histogramValues.binWidth;
        let yCount;
        for (let j = 0; j < data.length;) {
            yCount = yValues.filter((y) => y >= min && y < (min + (binWidth))).length;
            if ((min + binWidth) === max) {
                yCount += yValues.filter((y) => y >= max).length;
            }
            updatedData.push({
                'x': min + binWidth / 2,
                [series.yName]: yCount
            });
            min = min + binWidth;
            j += yCount;
        }
        return updatedData;
    }
    // eslint-disable-next-line jsdoc/require-returns-check
    /**
     * Calculates bin values.
     *
     * @returns null
     * @private
     */
    calculateBinValues(series) {
        const yValuesCount = series.histogramValues.yValues.length;
        const binWidth = series.histogramValues.binWidth;
        const mean = series.histogramValues.mean;
        const sDValue = series.histogramValues.sDValue;
        const pointsCount = 500;
        const min = series.xAxis.minimum ? parseInt(series.xAxis.minimum.toString()) : series.xMin;
        const max = series.xAxis.maximum ? parseInt(series.xAxis.maximum.toString()) : series.xMax;
        const points = series.points.length;
        let xValue;
        let yValue;
        const del = (max - min) / (pointsCount - 1);
        if (points) {
            for (let i = 0; i < pointsCount; i++) {
                xValue = min + i * del;
                yValue = (Math.exp(-(xValue - mean) * (xValue - mean) / (2 * sDValue * sDValue)) /
                    (sDValue * Math.sqrt(2 * Math.PI))) * binWidth * yValuesCount;
                series.yMin = series.yMin > yValue ? yValue : series.yMin;
                series.yMax = series.yMax < yValue ? yValue : series.yMax;
            }
        }
    }
    /**
     * Render Normal Distribution for Histogram series.
     *
     * @returns {void}
     * @private
     */
    renderNormalDistribution(series) {
        const min = series.xAxis.actualRange.min;
        const max = series.xAxis.actualRange.max;
        let xValue;
        let pointLocation;
        let yValue;
        let direction = '';
        let startPoint = 'M';
        const yValuesCount = series.histogramValues.yValues.length;
        const binWidth = series.histogramValues.binWidth;
        const mean = series.histogramValues.mean;
        const sDValue = series.histogramValues.sDValue;
        const pointsCount = 500;
        const del = (max - min) / (pointsCount - 1);
        const points = series.points.length;
        if (points) {
            for (let i = 0; i < pointsCount; i++) {
                xValue = min + i * del;
                yValue = Math.exp(-(xValue - mean) * (xValue - mean) / (2 * sDValue * sDValue)) /
                    (sDValue * Math.sqrt(2 * Math.PI));
                pointLocation = getPoint(xValue, yValue * binWidth * yValuesCount, series.xAxis, series.yAxis, series.chart.requireInvertedAxis);
                direction += startPoint + ' ' + (pointLocation.x) + ' ' + (pointLocation.y) + ' ';
                startPoint = 'L';
            }
        }
        const distributionLine = series.chart.renderer.drawPath(new PathOption(series.chart.element.id + '_Series_' + series.index + '_NDLine', 'transparent', 2, series.chart.themeStyle.errorBar, series.opacity, series.dashArray, direction), new Int32Array([series.clipRect.x, series.clipRect.y]));
        distributionLine.style.visibility = (!series.chart.enableCanvas) ? ((series.animation.enable &&
            series.chart.animateSeries) ? 'hidden' : 'visible') : null;
        if (!series.chart.enableCanvas) {
            series.seriesElement.appendChild(distributionLine);
        }
    }
    /**
     * Animates the series.
     *
     * @param  {Series} series - Defines the series to animate.
     * @returns {void}
     */
    doAnimation(series) {
        super.doAnimation(series);
        if (series.showNormalDistribution) {
            templateAnimate(series.seriesElement.lastElementChild, series.animation.duration, 500, 'FadeIn');
        }
    }
    /**
     * Get module name.
     */
    getModuleName() {
        return 'HistogramSeries';
        /**
         * return the module name
         */
    }
    /**
     * To destroy the histogram series.
     *
     * @returns {void}
     * @private
     */
    destroy() {
        /**
         * Destroy method performed here
         */
    }
}
